module.exports = __webpack_public_path__ + "static/logo-2b1adeca5bc05adcd4ab055346fd2cfa.jpeg";